import styles from "./buttonContacts.module.css";

import ImgBuilder from "../../assets/ImgBuilder";
// import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const ButtonContacts = () => {
  // const { t } = useTranslation();
  const navigate = useNavigate();
  
  return (
    <div onClick={() => navigate("/contacts")} className={styles.button}>
      <img alt="contacts" className={styles.iconContactItem} src={ImgBuilder.emailIcon} />
      Contact us
    </div>
  );
};
export default ButtonContacts;

